import React, { useEffect, useState } from 'react'
import TextInput from '../TextInput'
import Popover from 'react-awesome-popover'
import cx from 'classnames'
import { useTranslation } from 'react-i18next'

import './style.scss'

const RubricDescription = (props: any) => {
  const { t } = useTranslation()

  const [horizontalHeader, setHorizontalHeader] = useState(
    props.horizontalHeaderValues
      ? props.horizontalHeaderValues
      : [
          'Score Criteria',
          'Score for Criteria',
          'Description of Scoring Criteria',
        ],
  )
  const [isReachMaxCharCount, setIsReachMaxCharCount] = useState(false)
  const [verticalHeader, setVerticalHeader] = useState(
    props.verticalHeaderValues ? props.verticalHeaderValues : [''],
  )
  const [tableData, setTableData] = useState(
    props.tableValues
      ? props.tableValues
      : [
          { text: '', score: 1, keyword_scores: '' },
          { text: '', score: 1, keyword_scores: '' },
        ],
  )
  const [controlColumnCount, setControlColumnCount] = useState(
    props.columnCount
      ? props.columnCount
      : props.horizontalHeaderValues.length - 1,
  )
  const [controlRowCount, setControlRowCount] = useState(
    props.verticalHeaderValues
      ? props.verticalHeaderValues.length
      : props.rowCount,
  )

  useEffect(() => {
    if (props.horizontalHeaderValues.length === props.columnCount) {
      let temp = [...props.horizontalHeaderValues]
      temp.unshift('')
      setHorizontalHeader(temp)
    }
  }, [])

  useEffect(() => {
    !props.disableHeader && props.onHeaderChange(horizontalHeader)
  }, [horizontalHeader])

  useEffect(() => {
    props.onColumnHeaderChange && props.onColumnHeaderChange(verticalHeader)
  }, [verticalHeader])

  useEffect(() => {
    props.onAnswerKeyTableChange(tableData, controlRowCount, controlColumnCount)
  }, [tableData])

  const onVerticalHeaderCellChange = (value: any, headerIndex: any) => {
    if (
      !isReachMaxCharCount ||
      value?.length < verticalHeader[headerIndex]?.length
    ) {
      let trimValue = value
      if (props.maxCharCount) {
        trimValue = getRemainingContent(
          value,
          props.maxCharCount,
          getCurrentCharCount() - verticalHeader[headerIndex].length,
        )
      }
      let temp = [...verticalHeader]
      temp[headerIndex] = trimValue
      setVerticalHeader(temp)
    }
  }

  const onRowCellChange = (value: any, index: any) => {
    if (
      !isReachMaxCharCount ||
      value?.length < tableData[index]?.text?.length
    ) {
      let trimValue = value
      if (props.maxCharCount) {
        trimValue = getRemainingContent(
          value,
          props.maxCharCount,
          getCurrentCharCount() - tableData[index]?.text?.length,
        )
      }

      let temp = [...tableData]
      const regEx = new RegExp(
        /^(\d+(?:\.\d+)?)(?:\s?-\s?(\d+(?:\.\d+)?))?(\D*?)$/gm,
      )
      if (trimValue && index % 2 === 0) {
        if (regEx.test(trimValue)) {
          temp[index].text = trimValue
        }
      } else if (trimValue) {
        temp[index].text = trimValue
      } else {
        temp[index].text = ''
      }
      setTableData(temp)
    }
  }
  const getRemainingContent = (
    pastedcontent: any,
    maxCharCount: any,
    currentLenght: number,
  ) => {
    return pastedcontent.substr(0, maxCharCount - currentLenght)
  }

  const handleVerticalHeaderCellPaste = (event: any) => {
    let pastedContent = event.clipboardData.getData('text')
    let splitRows = pastedContent.split('\n')
    let pastedTableBodyData: any = []
    if (splitRows.length && splitRows[0].split('\t').length > 1) {
      let verticalHeaderRow: any = []
      splitRows.forEach((row: any, rowIndex: any) => {
        let splitCells = row.split('\t')
        verticalHeaderRow.push(splitCells.shift())
        if (rowIndex === 0 && splitCells.length) {
          setControlColumnCount(splitCells.length)
        }
        splitCells.forEach((cell: any) => {
          pastedTableBodyData.push({
            text: cell,
            score: 1,
            keyword_scores: '',
          })
        })
      })
      setTableData(pastedTableBodyData)
      setVerticalHeader(verticalHeaderRow)
    }
  }

  const handleRowCellPaste = (event: any) => {
    let pastedContent = event.clipboardData.getData('text')
    let splitRows = pastedContent.split('\n')
    let pastedTableBodyData: any = []
    if (splitRows.length && splitRows[0].split('\t').length > 1) {
      splitRows.forEach((row: any, index: any) => {
        let splitCells = row.split('\t')
        if (index === 0 && splitCells.length) {
          let difference = splitCells.length - controlColumnCount
          if (difference > 0) {
            let updatedHorizontalHeader = [...horizontalHeader]
            for (let i = 0; i < difference; i++) {
              updatedHorizontalHeader.push('')
            }
            setHorizontalHeader(updatedHorizontalHeader)
          }
          setControlColumnCount(splitCells.length)
        }
        splitCells.forEach((cell: any) => {
          pastedTableBodyData.push({
            text: cell,
            score: 1,
            keyword_scores: '',
          })
        })
      })
      setTableData(pastedTableBodyData)
    }
  }

  const onCellKeywordChange = (value: any, index: any) => {
    let temp = [...tableData]
    temp[index].keyword_scores = value
    setTableData(temp)
  }

  const onCellScoreChange = (value: any, index: any) => {
    let temp = [...tableData]
    temp[index].score = value
    setTableData(temp)
  }

  const addRow = (targetIndex: any) => {
    let tempTableData = [...tableData]
    let tempVerticalHeader = [...verticalHeader]
    if (targetIndex || targetIndex === 0) {
      for (
        let i = (targetIndex + 1) * controlColumnCount;
        i < controlColumnCount * (targetIndex + 2);
        i++
      ) {
        tempTableData.splice(i, 0, {
          text: '',
          score: 1,
          keyword_scores: '',
        })
      }
      tempVerticalHeader.splice(targetIndex + 1, 0, '')
    } else {
      for (let i = 1; i <= controlColumnCount; i++) {
        tempTableData.push({
          text: '',
          score: 1,
          keyword_scores: '',
        })
      }
      tempVerticalHeader.push('')
    }
    setTableData(tempTableData)
    setVerticalHeader(tempVerticalHeader)
    setControlRowCount((data: any) => data + 1)
  }

  const removeRow = (targetRow: any) => {
    let tempTableData = [...tableData]
    let startIndex = targetRow * controlColumnCount
    for (let i = 1; i <= controlColumnCount; i++) {
      tempTableData.splice(startIndex, 1)
    }
    setTableData(tempTableData)
    let tempVerticalHeader = [...verticalHeader]
    tempVerticalHeader.splice(targetRow, 1)
    setVerticalHeader(tempVerticalHeader)
    setControlRowCount((data: any) => data - 1)
  }

  const divideArray = () => {
    let temp = [...tableData]
    const result = new Array(Math.ceil(temp.length / controlColumnCount))
      .fill(null)
      .map(_ => temp.splice(0, controlColumnCount))

    return result
  }

  const getCurrentCharCount = () => {
    const table = divideArray()
    let c = 0
    c = table?.reduce((acc: any, row: any, i: any) => {
      if (verticalHeader[i].length > 0) {
        return (
          acc +
          verticalHeader[i].length +
          row[0]?.text.length +
          row[1]?.text.length
        )
      }
      return acc
    }, c)
    return c
  }

  const getTableBody = () => {
    let body = []
    body = divideArray().map((row, rowIndex: any) => (
      <tr className="match-row">
        <th className="match-input-wrapper">
          <TextInput
            disabled={props.viewOnly}
            placeholder={'Input Scoring Criteria \n(Eg: Integration)'}
            useTextArea
            value={verticalHeader[rowIndex]}
            inputChange={(event: any) =>
              onVerticalHeaderCellChange(event.target.value, rowIndex)
            }
            onPaste={handleVerticalHeaderCellPaste}
          />
        </th>
        {row.map((cell, cellIndex: any) => (
          <td className="match-input-wrapper remove-up-down-arrow">
            <TextInput
              disabled={props.viewOnly}
              useTextArea={cellIndex !== 0}
              value={cell.text}
              inputChange={(event: any) =>
                onRowCellChange(
                  event.target.value,
                  cellIndex + controlColumnCount * rowIndex,
                )
              }
              // inputType={cellIndex === 0 && "number"}
              onPaste={handleRowCellPaste}
              placeholder={
                cellIndex === 0
                  ? 'Enter score or score range (Eg: 2 or 1-2)'
                  : 'Provide a description of the criteria for evaluation. \n(Eg: Explain how the strategy will integrate with or support other existing tools.)'
              }
            />
            {props.scoredBy.value === 'enhanced_keywords' && (
              <div className="quiz-table-cell-toolbar">
                <Popover
                  placement={'top-end'}
                  overlayColor={'rgba(0,0,0,0)'}
                  className="custom-popover"
                  arrowProps={{
                    className: 'quiz-table-popover-arrow',
                  }}
                  arrow={false}
                >
                  {!props.viewOnly && (
                    <button
                      className="toolbar-btn cell-property-btn"
                      title="Edit keywords and score"
                    >
                      <i className="icon-edit-line toolbar-icon" />
                    </button>
                  )}
                  <div className="popover-box">
                    <TextInput
                      disabled={props.viewOnly}
                      useTextArea
                      label="Keywords"
                      value={cell.keyword_scores}
                      inputChange={(event: any) =>
                        onCellKeywordChange(
                          event.target.value,
                          cellIndex + controlColumnCount * rowIndex,
                        )
                      }
                    />
                    <div className="half-clearfix" />
                    <TextInput
                      disabled={props.viewOnly}
                      label="Score"
                      inputType="number"
                      value={cell.score}
                      inputChange={(event: any) =>
                        onCellScoreChange(
                          event.target.value,
                          cellIndex + controlColumnCount * rowIndex,
                        )
                      }
                    />
                  </div>
                </Popover>
              </div>
            )}
          </td>
        ))}
        {!props.viewOnly && (
          <div className="quiz-table-row-toolbar">
            <button
              onClick={() => {
                addRow(rowIndex)
              }}
              className="toolbar-btn row-add-btn"
              title="Add row"
            >
              <i className="icon-add toolbar-icon" />
            </button>
            {controlRowCount > 1 && (
              <button
                onClick={() => {
                  removeRow(rowIndex)
                }}
                className="toolbar-btn row-remove-btn"
                title="Remove row"
              >
                <i className="icon-delete toolbar-icon" />
              </button>
            )}
          </div>
        )}
      </tr>
    ))
    return body
  }

  useEffect(() => {
    if (props?.maxCharCount && getCurrentCharCount() >= props?.maxCharCount) {
      setIsReachMaxCharCount(true)
    } else {
      setIsReachMaxCharCount(false)
    }
  }, [tableData, props.maxCharCount, verticalHeader])

  return (
    <div className="quiz-table-master-container">
      <div className="quiz-table-wrapper">
        <table className="match-editor">
          <thead className="">
            {horizontalHeader?.map((value: any, index: any) => (
              <th className="match-header-wrapper ">{<div>{value}</div>}</th>
            ))}
          </thead>
          <tbody>{getTableBody()}</tbody>
        </table>
      </div>
      {props?.maxCharCount && (
        <div
          className={cx({
            'page-count des': true,
            'clr-error': isReachMaxCharCount,
          })}
        >
          <span className={cx({ 'clr-error': isReachMaxCharCount })}>
            {`${t('Characters')} : ${getCurrentCharCount()} / ${
              props.maxCharCount
            }`}
          </span>
        </div>
      )}
    </div>
  )
}

export default RubricDescription
